"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALL_NETWORKS_TYPES = exports.Network = void 0;
var Network;
(function (Network) {
    Network[Network["MAINNET"] = 1] = "MAINNET";
    Network[Network["GOERLI"] = 5] = "GOERLI";
    Network[Network["POLYGON"] = 137] = "POLYGON";
    Network[Network["MUMBAI"] = 80001] = "MUMBAI";
    // OPTIMISTIC = 10,
    // ARBITRUM = 200,
    Network[Network["BSC"] = 56] = "BSC";
    Network[Network["BSC_TESTNET"] = 97] = "BSC_TESTNET";
})(Network = exports.Network || (exports.Network = {}));
exports.ALL_NETWORKS_TYPES = ['ethereum', 'polygon', 'bsc'];
